import Reflux from 'reflux';

// eslint-disable-next-line no-unused-vars
const RealTimeActions = Reflux.createActions({
  teamCreatedRealTime: {},
  teamMutatedRealTime: {},
  teamUpdatePhotoRealTime: {},
  eventUpdatePhotoRealTime: {},
  eventCreatedRealTime: {},
  eventMutatedRealTime: {},
  eventUpdateRoleRealTime: {},
  eventCreateDocRealTime: {},
  eventDuplicationCompletedRealtime: {},
  eventSaveDocChangesRealTime: {},
  showCreatedRealTime: {},
  showMutatedRealTime: {},
  showRecountedRealTime: {},
  showResetAllStartTimesRealTime: {},
  subscribe: {},
  unsubscribe: {},
  subscribeToShow: {},
  subscribeToEvent: {},
  subscribeToEvents: {},
  subscribeToTeam: {},
  subscribeToUser: {},
  subscribeToPrompterUser: {},
  unsubscribeToTeams: {},
  unsubscribeFromEvents: {},
  unsubscribeFromTeams: {},
  unsubscribeFromEvent: {},
  unsubscribeFromTeam: {},
  unsubscribeFromUser: {},
  rowUpdatedRealTime: {},
  removeGlobalElementReferencesRealTime: {},
  publishLatestGlobalElementRowChangesToShowRowRealTime: {},
  publishShowRowChangesToGlobalElementRowRealTime: {},
  itemRowRestoredRealTime: {},
  itemRowCellMutatedRealTime: {},
  itemRowMultipleCellsMutatedRealTime: {},
  itemRowNoteMutatedRealTime: {},
  itemRowProofAddedRealTime: {},
  itemRowProofRemovedRealTime: {},
  itemRowProofNoteUpdatedRealTime: {},
  itemRowProofHistoryClearedRealTime: {},
  showProofsClearedRealTime: {},
  publishGlobalElementChangesRealTime: {},
  globalElementItemRowsAddedRealTime: {},
  itemRowsAddedRealTime: {},
  itemRowDeletedRealTime: {},
  itemRowsDeletedRealTime: {},
  itemRowsMovedRealTime: {},
  itemRowOrderUpdatedRealTime: {},
  itemRowTrackedRealTime: {},
  itemRowMovedFromSourceToDestinationRealTime: {},
  deleteActualDurationsRealTime: {},
  userRemovedTrackingRealTime: {},
  columnUpdatedRealTime: {},
  setColumnOrderFromUserRealTime: {},
  createdGlobalElementFromShowRowRealTime: {},
  itemRowMutatedRealTime: {},
  itemSetListColumnCreatedRealTime: {},
  itemSetListColumnRestoredRealTime: {},
  itemSetListColumnDeletedRealTime: {},
  itemSetListColumnMovedRealTime: {},
  itemSetListItemSettingsUpdatedRealTime: {},
  cueClockMutatedRealTime: {},
  itemSetListItemRowSettingsUpdatedRealTime: {},
  itemRowPresentationUpdatedRealTime: {},
  eventFolderUpdatedRealtime: {},
  eventFolderCreatedRealtime: {},
  eventObjectMovedRealtime: {},
  eventObjectArchivedRealtime: {},
  eventObjectRestoredRealtime: {},
});

export default RealTimeActions;
